import React, { Component, Fragment } from 'react';
import Social from '@ertelecom/ui-react/components/buttons/social';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import MobileStoreButton from '@ertelecom/ui-react/components/buttons/mobileStoreButton';
import { FooterLinks } from './footer-links';
import Support from './support';
import Addresses from './addresses';
import EmailWidget from './emailWidget';
import Link from 'next/link';
import * as ST from './styled';
import { getMobileLink } from '~/src/helpers/mobile';
import { MOBILE_OS } from '~/src/constants';
import { NON_BREAKING_SPACE } from '~/src/constants/simbols';
import linksData from './data.json';
import { vkontakte, facebook, twitter, odnoklassniki, instagram, youtube } from './icons';

export class Footer extends Component {
    state = {
        services: {},
        isOpenAddresses: false,
    };

    constructor(props) {
        super(props);
        const { city, menuItems } = props;
        const { internet, ctv, ktv, telephony } = city;
        this.state.services = this.generateServiceObj(
            internet,
            ctv,
            ktv,
            telephony,
            this.isDomofon(menuItems)
        );
    }

    updateOpenAddresses = (value) => {
        this.setState({ isOpenAddresses: value });
    };

    componentDidUpdate(prevProps) {
        const { accessToken, city, menuItems } = this.props;
        if (prevProps.accessToken !== accessToken || prevProps.city.domain !== city.domain) {
            const { internet, ctv, ktv, telephony } = city;
            this.setState({
                services: this.generateServiceObj(
                    internet,
                    ctv,
                    ktv,
                    telephony,
                    this.isDomofon(menuItems)
                )
            });
        }
    }

    isDomofon = (menuItems) => {
        return menuItems?.some(item =>
            item.children.some(submenuItem => submenuItem.link === '/domofon'));
    }

    generateServiceObj = (internet, ctv, ktv, telephony, domofon) => {

        const { city: { domain } } = this.props;

        const services = {
            title: 'Услуги',
            linkList: []
        };

        if (internet && (ktv || ctv)) {
            services.linkList.push({
                'text': 'Интернет + ТВ',
                'link': '/bundles'
            });
        }
        if (internet) {
            services.linkList.push({
                'text': 'Интернет',
                'link': '/internet'
            });
        }
        if (ctv) {
            services.linkList.push({
                'text': 'Цифровое ТВ',
                'link': '/domru-tv'
            });
        }
        if (ktv && domain !== 'msk') {
            services.linkList.push({
                'text': 'Кабельное ТВ',
                'link': '/domru-tv/ktv'
            });
        }
        if (telephony && domain !== 'msk' && domain !== 'angarsk') {
            services.linkList.push({
                'text': 'Телефон',
                'link': '/telephone'
            });
        }
        if (domofon) {
            services.linkList.push({
                'text': 'Домофон',
                'link': '/domofon'
            });
        }
        return services;
    };

    onClickHandler = (mobileOs, e) => {
        e.preventDefault();
        const { accessToken, refreshToken, agreement, city } = this.props;
        window.location = getMobileLink(accessToken, refreshToken, agreement, city, mobileOs);
    };

    render() {
        const { city, dealersContacts, text, accessToken, withEmailWidget, emailWidgetText } = this.props;
        const { services } = this.state;
        const { domain, billingDomain } = city;
        const cause = [
            { cause: 'Создать обращение', link: '/service/feedback' }
        ];
        const hasServices = services.linkList !== undefined && services.linkList.length > 0;

        return (
            <>
                {withEmailWidget && <EmailWidget mainText={emailWidgetText} />}
                <ST.Footer>
                    <ST.Wrap>
                        <ST.FooterTop>
                            <ST.FooterSupport>
                                <Support
                                    hasContacts={!!dealersContacts?.length}
                                    city={city}
                                    cause={cause}
                                    updateOpenAddresses={this.updateOpenAddresses}
                                    isOpenAddresses={this.state.isOpenAddresses}
                                    data-test='support'
                                >
                                    <ST.SocialContainer>
                                        <ST.SocialText>
                                            Мы в соц. сетях
                                        </ST.SocialText>
                                        <Social data-test='social' socials={[
                                            { link: 'https://vk.com/domru', background: 'white', img: vkontakte },
                                            { link: 'https://www.facebook.com/domru.ru/', background: 'white', img: facebook },
                                            { link: 'https://twitter.com/domru_', background: 'white', img: twitter },
                                            { link: 'https://ok.ru/domru', background: 'white', img: odnoklassniki },
                                            { link: 'https://www.instagram.com/domru_ru/', background: 'white', img: instagram },
                                            { link: 'https://www.youtube.com/channel/UCH3YE5jHybxKtMk5xT2SRhA', background: 'white', img: youtube },
                                        ]} />
                                    </ST.SocialContainer>
                                </Support>
                            </ST.FooterSupport>
                            <ST.FooterService>
                                <ST.CompanyService>
                                    <Addresses
                                        dealersContacts={dealersContacts}
                                        updateOpenAddresses={this.updateOpenAddresses}
                                        isOpenAddresses={this.state.isOpenAddresses}
                                        city={city}
                                        data-test='address'
                                    />
                                    <ST.LinksWrap>
                                        {
                                            hasServices
                                                ? <FooterLinks key='services' title={services.title} citydomain={domain}
                                                    billingDomain={billingDomain} token={accessToken}
                                                    linkList={services.linkList} />
                                                : ''
                                        }

                                        <RenderFooterLinks />
                                    </ST.LinksWrap>
                                    <ST.Store>
                                        <PayButton data-test='payment-btn' />
                                        <MobileStoreButton onClick={(e) => this.onClickHandler(MOBILE_OS.iphone, e)} store='AppStore' data-test='app-store' />
                                        <MobileStoreButton onClick={(e) => this.onClickHandler(MOBILE_OS.android, e)} store='GooglePlay' data-test='google-play' />
                                    </ST.Store>
                                </ST.CompanyService>
                            </ST.FooterService>
                        </ST.FooterTop>
                        <ST.FooterBottom>
                            <Copyright data-test='policy' />
                            {
                                text &&
                                <ST.FooterText>
                                    {text}
                                </ST.FooterText>
                            }
                        </ST.FooterBottom>
                    </ST.Wrap>
                </ST.Footer>
            </>
        );
    }
}

/**
 *
 * @param {string} billingDomain
 * @param {string} domain
 * @param {string} accessToken
 * @return {JSX.Element}
 * @constructor
 */
function RenderFooterLinks({ billingDomain, domain, accessToken }) {
    return <Fragment>
        {
            linksData.map((item, index) => (
                <Fragment key={index}>
                    {index === 1 && (
                        <ST.ViewInMobile>
                            <PayButton data-test='payment-btn' />
                        </ST.ViewInMobile>
                    )}
                    <FooterLinks
                        title={item.title}
                        citydomain={domain}
                        billingDomain={billingDomain}
                        token={accessToken}
                        linkList={item.linkList} />
                </Fragment>
            ))
        }
    </Fragment>;
}

function PayButton() {
    return (
        <Link
            href='/payments'
            passHref
        >
            <ST.PayBtn>
                <StyledButton type='secondary' text='Оплатить услуги'
                    data-test='payment-btn' />
            </ST.PayBtn>
        </Link>
    );
}

function Copyright() {
    return <ST.Copyright>
        <ST.CopyrightCompany>&copy; АО &laquo;ЭР-Телеком Холдинг&raquo; 2011-{new Date().getFullYear()}</ST.CopyrightCompany>
        <ST.CopyrightText>Продолжая использовать наш сайт, вы даете согласие на обработку файлов
            cookies <br />и других пользовательских данных, в соответствии с{NON_BREAKING_SPACE}
            <ST.CopyrightLink href='/policy/app' >Политикой конфиденциальности</ST.CopyrightLink>.
        </ST.CopyrightText>
    </ST.Copyright>;
}
